import { Outlet, useParams } from '@/js/libs/router';
import { useRolesMatch, Roles } from '@/js/libs/use-auth';

import Status from 'src/scenes/Status/index.ts';
import type { BroadcastRouteParams } from '../types.ts';
import { BroadcastUrlTypes } from '../types.ts';

const BROADCAST_ROLES = {
  [BroadcastUrlTypes.TV]: Roles.MANAGE_TV_PRODUCTS,
  [BroadcastUrlTypes.RADIO]: Roles.MANAGE_RADIO_PRODUCTS,
};
export const BroadcastRoleChecker = () => {
  const { broadcastType } = useParams<BroadcastRouteParams>();
  const role = BROADCAST_ROLES[broadcastType];
  const hasAccess = useRolesMatch({ roles: role });

  if (!hasAccess) {
    return <Status.NotFound />;
  }

  return <Outlet />;
};
